"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuoteToolRouterProvider = exports.BaseQuoteToolRoutes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _riskidReactjsTs = require("@transmitsecurity/riskid-reactjs-ts");
var _gtmService = require("../../data/gtmService/gtmService");
var _baseQuoteTool = require("./baseQuoteTool");
var _StepContent = require("../StepContent/StepContent");
var _brandContext = require("../../contextProviders/brandContext");
var _defaultLayout = require("../../layouts/defaultLayout");
var _brandContextProvider = require("../../contextProviders/brandContextProvider");
var _quoteToolDataContextProvider = require("../../contextProviders/quoteToolDataContextProvider");
var _emailQuotePanelContextProvider = require("../../contextProviders/emailQuotePanelContextProvider");
var _RouteContent = require("../RouteContent/RouteContent");
var _componentKeyMap = require("../Steps/componentKeyMap");
var _steps = require("../../constants/app/steps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var QuoteToolRouterProvider = exports.QuoteToolRouterProvider = function QuoteToolRouterProvider() {
  var _transmitSecurity$env;
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    env = _useContext.env,
    _useContext$activeBra = _useContext.activeBrandContext,
    _useContext$activeBra2 = _useContext$activeBra.brand,
    brandKey = _useContext$activeBra2.key,
    broker = _useContext$activeBra2.broker,
    customRouteDefinitions = _useContext$activeBra.customRouteDefinitions,
    stepDefinitions = _useContext$activeBra.steps.StepDefinitions,
    transmitSecurity = _useContext$activeBra.transmitSecurity;
  (0, _react.useMemo)(function () {
    return (0, _gtmService.getGtmService)().pushBroker(broker);
  }, [broker]);
  var url = (0, _react.useMemo)(function () {
    var _document;
    return new URL((_document = document) === null || _document === void 0 ? void 0 : _document.location);
  }, []);
  var router = (0, _react.useMemo)(function () {
    return (0, _reactRouterDom.createBrowserRouter)((0, _reactRouterDom.createRoutesFromElements)( /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      element: /*#__PURE__*/_react["default"].createElement(_defaultLayout.DefaultLayout, null),
      errorElement: /*#__PURE__*/_react["default"].createElement("div", null, " Something went wrong ")
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: "/",
      element: /*#__PURE__*/_react["default"].createElement(_emailQuotePanelContextProvider.EmailQuoteContextProvider, {
        stepDefinitions: stepDefinitions
      }, /*#__PURE__*/_react["default"].createElement(_baseQuoteTool.BaseQuoteTool, null))
    }, stepDefinitions && stepDefinitions.map(function (stepDefinition, index) {
      var url = stepDefinition.url,
        id = stepDefinition.id;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: "".concat(brandKey, "_").concat(id),
        path: url,
        element: /*#__PURE__*/_react["default"].createElement(_StepContent.StepContent, {
          activeStepIndex: index
        })
      });
    }), customRouteDefinitions && customRouteDefinitions.map(function (customRouteDefinition) {
      var url = customRouteDefinition.url,
        id = customRouteDefinition.id,
        componentKey = customRouteDefinition.componentKey;
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
        key: "".concat(brandKey, "_").concat(id),
        path: url,
        element: /*#__PURE__*/_react["default"].createElement(_RouteContent.RouteContent, {
          content: _componentKeyMap.ComponentKeyMap[componentKey]
        })
      });
    }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      index: true,
      element: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
        to: {
          pathname: stepDefinitions.find(function (step) {
            return step.id === _steps.StepIndex.youAndYourPets;
          }).url,
          search: url.search
        }
      })
    })))));
  }, [brandKey, customRouteDefinitions, stepDefinitions, url]);
  return transmitSecurity !== null && transmitSecurity !== void 0 && transmitSecurity.enabled ? /*#__PURE__*/_react["default"].createElement(_riskidReactjsTs.TSAccountProtectionProvider, {
    clientId: transmitSecurity === null || transmitSecurity === void 0 || (_transmitSecurity$env = transmitSecurity[env]) === null || _transmitSecurity$env === void 0 ? void 0 : _transmitSecurity$env.clientId
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.RouterProvider, {
    router: router,
    key: brandKey
  })) : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.RouterProvider, {
    router: router,
    key: brandKey
  });
};
var BaseQuoteToolRoutes = exports.BaseQuoteToolRoutes = function BaseQuoteToolRoutes(_ref) {
  var env = _ref.env,
    brandConfig = _ref.brandConfig,
    _ref$staffMode = _ref.staffMode,
    staffMode = _ref$staffMode === void 0 ? false : _ref$staffMode,
    _ref$useMocks = _ref.useMocks,
    useMocks = _ref$useMocks === void 0 ? false : _ref$useMocks,
    _ref$showBrandSwitch = _ref.showBrandSwitch,
    showBrandSwitch = _ref$showBrandSwitch === void 0 ? false : _ref$showBrandSwitch,
    quoteData = _ref.quoteData;
  return /*#__PURE__*/_react["default"].createElement(_brandContextProvider.BrandContextProvider, {
    env: env,
    useMocks: useMocks,
    staffMode: staffMode,
    brandConfig: brandConfig,
    showBrandSwitch: showBrandSwitch
  }, /*#__PURE__*/_react["default"].createElement(_quoteToolDataContextProvider.QuoteToolDataContextProvider, {
    quoteData: quoteData
  }, /*#__PURE__*/_react["default"].createElement(QuoteToolRouterProvider, null)));
};
BaseQuoteToolRoutes.propTypes = {
  env: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  brandConfig: _propTypes["default"].any,
  staffMode: _propTypes["default"].bool,
  useMocks: _propTypes["default"].bool,
  showBrandSwitch: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  quoteData: _propTypes["default"].any
};